// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageContent-module__contentContainer--2U_dY{display:flex;flex-direction:column;height:100%;min-width:17.778rem}.PageContent-module__contentContainer--2U_dY>div{flex-grow:1}.PageContent-module__noScroll--x-9cn{overflow:hidden}", ""]);
// Exports
exports.locals = {
	"contentContainer": "PageContent-module__contentContainer--2U_dY",
	"noScroll": "PageContent-module__noScroll--x-9cn"
};
module.exports = exports;
